<template>
  <div class="w-full flex" v-loading="loading">
    <div class="w-4/12 p-2">
      <div class="border rounded-md px-4">
        <el-form :model="form" ref="form">
          <!-- Report Period Type -->
          <el-form-item prop="dataForm">
            <h5 class="text-base font-bold text-black mt-2">Report Period</h5>
            <el-select
              v-model="form.dataForm"
              @change="onChangePicker"
              placeholder="Select Report Period"
              class="w-full"
            >
              <el-option
                v-for="item in dateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <!-- Period Range -->
          <h5 class="text-base font-bold text-black my-2">Period Range</h5>
          <div class="flex justify-between">
            <el-form-item prop="startDate">
              <el-date-picker
                v-model="form.startDate"
                :picker-options="datePickerOptions"
                :type="periodDatePickerType"
                placeholder="Start Period"
                value-format="yyyy-MM-dd"
                @change="validateDate"
                class="mr-1"
                style="width: 98%;"
              />
            </el-form-item>
            <el-form-item prop="endDate">
              <el-date-picker
                v-model="form.endDate"
                :picker-options="datePickerOptions"
                :type="periodDatePickerType"
                placeholder="End Period"
                value-format="yyyy-MM-dd"
                @change="validateDate"
                class="ml-1"
                style="width: 98%;"
              />
            </el-form-item>
          </div>
          <!-- Type Sensor -->
          <el-form-item>
            <h5 class="text-base font-bold text-black">Sensor Type</h5>
            <el-select
              v-model="form.sensorType"
              @change="onChangeTypeSensor"
              placeholder="Select Sensor Type"
              class="w-full"
            >
              <el-option
                v-for="item in sensorTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <!-- Dropdown Report -->
        <h5 class="text-base font-bold text-black">Sub Devices</h5>
        <div class="border mt-2 h-56 rounded overflow-auto py-2">
          <el-tree
            class=""
            :data="checkboxes"
            show-checkbox
            node-key="id"
            @check="CheckedNodes"
            :default-expanded-keys="[]"
            :default-checked-keys="[]"
          />
        </div>

        <!-- Submit button -->
        <div class="flex mt-4 mb-4 justify-end">
          <el-button type="primary" @click="submit">Submit</el-button>
        </div>
      </div>
    </div>
    <div class="w-8/12 p-2">
      <div class="border rounded-md p-3">
        <div v-if="chartBarVisible">
          <div class="flex justify-between">
            <div>
              <img
                src="@/assets/images/logo-corp.png"
                alt="logo-corp"
                class="h-16"
              />
            </div>
            <div class="flex">
              <div
                class="h-8 w-8 flex justify-center items-center bg-blue-600 hover:bg-blue-700 rounded-full text-white cursor-pointer"
                @click="printToPDF()"
              >
                <i class="el-icon-download text-lg"></i>
              </div>
            </div>
          </div>
          <div class="bg-white w-full flex justify-center">
            <bar-chart
              ref="canvas"
              style="width: 100%;"
              :height="200"
              :chart-data="dataCollectionReport"
              :options="chartOptionsReport"
            />
          </div>
          <div class="mt-4">
            <table v-if="false" class="w-full hidden">
              <thead>
                <tr class="bg-gray-200">
                  <th class="border py-1">Sub Device Name</th>
                  <th class="border py-1">Timestamp</th>
                  <th class="border py-1">Value</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) of tableData"
                  :key="index"
                  :class="index % 2 === 0 ? 'bg-gray-100' : ''"
                >
                  <td class="border px-2 py-1">{{ item.deviceName }}</td>
                  <td class="border px-2 py-1 text-right">
                    {{ item.timestamp }}
                  </td>
                  <td class="border px-2 py-1 text-right">
                    {{ `${item.value}${item.unit}` }}
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="w-full">
              <thead class="bg-gray-200">
                <tr class="border py-1">
                  <th>Datetime</th>
                  <th v-for="(item, index) of tableHeaders" :key="index">
                    {{ item }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, key, index) in tableData"
                  :key="key"
                  :class="index % 2 === 0 ? 'bg-gray-100' : ''"
                >
                  <td class="border px-2 py-1">{{ key }}</td>
                  <td
                    v-for="(childItem, childItemIndex) of item"
                    :key="childItemIndex"
                    class="border px-2 py-1 text-right"
                  >
                    {{ childItem.value }}{{ childItem.unit }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="h-64 text-center">
          <i class="el-icon-info"></i> Please do fulfill fields on the left side
          first to display report data
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imagesLib from './images.json'
import BarChart from '@/components/Chart/BarChart.js'
import LineChart from '@/components/Chart/LineChart.js'
import dropdownReportJson from '@/assets/json/dropdownReport.json'
import averageReportBySubDeviceNameJson from '@/assets/json/averageReportBySubDeviceName.json'
import moment from 'moment'
import lodash from 'lodash'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
pdfMake.vfs = pdfFonts.pdfMake.vfs

export default {
  components: {
    BarChart,
    LineChart
  },
  data() {
    return {
      loading: false,
      chartBarVisible: false,
      chartBase64: '',
      dataCollectionReport: null,
      chartOptionsReport: {
        bezierCurve: false,
        animation: {
          onComplete: this.chartOnLoadComplete
        },
        title: {
          display: true,
          text: 'Average By Sub Device Name',
          fontSize: 17
        },
        legend: {
          // display: false,
          labels: {
            fontColor: 'black',
            usePointStyle: true
          },
          position: 'bottom'
        },
        scales: {
          yAxes: [
            {
              gridLines: { color: '#607d8b' },
              ticks: {
                fontColor: 'black',
                // min: 0,
                suggestedMin: 15
              },
              scaleLabel: {
                display: true,
                labelString: ''
              }
            }
          ],
          xAxes: [
            {
              gridLines: { color: '' },
              ticks: {
                fontColor: 'black'
              }
            }
          ]
        }
      },
      form: {
        startDate: '',
        endDate: '',
        reportType: '',
        dataForm: 'daily_avg',
        sensorType: ''
      },
      dateOptions: [
        {
          value: 'daily_avg',
          label: 'Daily'
        },
        {
          value: 'monthly_avg',
          label: 'Monthly'
        },
        {
          value: 'yearly_avg',
          label: 'Yearly'
        }
      ],
      sensorTypeOptions: [],
      datePickerOptions: '',
      periodDatePickerType: 'date',
      checkboxes: [],
      dropdownReport: [],
      checkedNodes: [],
      tableData: [],
      tableHeaders: []
    }
  },
  mounted() {
    this.loading = true

    this.fetchDropdownReport()
  },
  methods: {
    createChart(data = {}) {
      this.chartBarVisible = true

      const labels = data.ListLabel
      const datalist = data.AverageHistorical.map((item) => item.DecimalVal)
      this.chartOptionsReport.scales.yAxes[0].scaleLabel.labelString =
        data.AverageHistorical[0]?.Unit

      this.dataCollectionReport = {
        labels: labels,
        datasets: [
          {
            type: 'line',
            label: `AVERAGE VALUE OF ${
              this.sensorTypeOptions.find(
                (sensorType) => sensorType.value === this.form.sensorType
              )?.label
            }`,
            backgroundColor: '#6199CC',
            borderColor: '#6199CC',
            strokeColor: '#79D1CF',
            data: datalist,
            fill: false,
            pointRadius: 3
          }
        ]
      }

      // setTimeout(() => {
      //   try {
      //     const chartBase64 = this.$refs.canvas.$refs.canvas.toDataURL()
      //     console.log('inimang chartBase64', chartBase64)
      //   } catch (err) {
      //     console.log('inimang error chartBase64', err)
      //   }
      // }, 3000)
    },
    async submit() {
      this.loading = true

      try {
        // console.log('inimang data', this.checkedNodes)

        // Validation
        if (this.form.startDate === '' || this.form.endDate === '') {
          this.$message.error('Please choose date correctly')
          this.loading = false
          return
        } else if (this.form.sensorType === '') {
          this.$message.error('Please choose sensor type first')
          this.loading = false
          return
        } else if (this.checkedNodes.length < 1) {
          this.$message.error('Please check any sub device first')
          this.loading = false
          return
        }
        // End of validation

        const data = {
          dataForm: this.form.dataForm,
          typeSensor: this.form.sensorType,
          startDate: this.form.startDate,
          endDate: this.form.endDate,
          SubDeviceName: [...this.checkedNodes.map((item) => item.label)]
        }

        const res = await this.$axios.post(
          'Report/PostCreateAverageReportBySubDeviceName',
          data
        )

        let historicalValues = []

        res.data.ListOfSensor.forEach((item) => {
          item.HistoricalValue.forEach((value) => {
            historicalValues.push({
              deviceName: item.SubDeviceName,
              value: value.DecimalVal,
              timestamp: moment(value.Timestamp).format('DD-MMM-YYYY'),
              unit: value.Unit
            })
          })
        })

        // Assign tableheaders for table purpose by device names
        const tableHeaders = historicalValues.map((item) => item.deviceName)
        this.tableHeaders = new Set(tableHeaders)

        // Should group historicalvalues by timestamp for table purposes
        let groupedByTimestamp = lodash.groupBy(historicalValues, function (
          history
        ) {
          return history.timestamp
        })
        this.tableData = groupedByTimestamp

        this.createChart(res.data)
      } catch (err) {
        this.loading = false
      }

      this.loading = false
    },
    async fetchDropdownReport() {
      try {
        const res = await this.$axios.get('Sensor/DropdownReport')

        this.dropdownReport = res.data

        res.data.forEach((item) => {
          this.sensorTypeOptions.push({
            value: item.value,
            label: item.label
          })
        })

        this.loading = false
      } catch (err) {
        console.log(err)
        this.loading = false
      }
      this.loading = false
    },
    onChangePicker() {
      if (this.form.dataForm == 'monthly_avg')
        this.periodDatePickerType = 'month'
      else if (this.form.dataForm == 'yearly_avg')
        this.periodDatePickerType = 'year'
      else this.periodDatePickerType = 'date'

      this.form.startDate = ''
      this.form.endDate = ''
    },
    onChangeTypeSensor() {
      // Reset checkedNodes
      this.checkedNodes = []

      // Find one dropdownReport data which its value equals to form.sensorType
      const selectedDropdownReport = this.dropdownReport.find(
        (item) => item.value === this.form.sensorType
      )
      let index = 1,
        checkboxes = []

      selectedDropdownReport.listSubDevice.forEach((item) => {
        checkboxes.push({
          id: index,
          label: item.subdevice
        })
        index++
      })

      this.checkboxes = checkboxes
    },
    validateDate() {
      if (this.form.startDate != '' && this.form.endDate != '') {
        let temp1 = new Date(this.form.startDate)
        let temp2 = new Date(this.form.endDate)
        if (temp1 > temp2) {
          this.form.endDate = ''
          this.$message.error('End Period must be greater than Start Period')
        }
      }
    },
    CheckedNodes(leafOnly, includeHalfChecked) {
      const indexOfLeaf = this.checkedNodes.indexOf(leafOnly)

      if (indexOfLeaf < 0) {
        this.checkedNodes.push(leafOnly)
      } else {
        this.checkedNodes.splice(indexOfLeaf, 1)
      }
    },
    chartOnLoadComplete() {
      try {
        const chartBase64 = this.$refs.canvas.$refs.canvas.toDataURL()
        this.chartBase64 = chartBase64
      } catch (err) {
        console.log(err)
      }
    },
    printToPDF() {
      try {
        let tableHeaders = [
          { text: 'Datetime', alignment: 'center', style: 'tableHeader' }
        ]
        this.tableHeaders.forEach((item) => {
          tableHeaders.push({
            text: item,
            alignment: 'center',
            style: 'tableHeader'
          })
        })

        let body = [[...tableHeaders.map((item) => item)]]

        Object.entries(this.tableData).forEach((item) => {
          // body.push([item[0], ...item[1].map(a => `${a.value}${a.unit}`)])
          body.push([
            { text: item[0], alignment: 'center', style: 'textSmall' },
            ...item[1].map((a) => {
              return {
                text: `${a.value}${a.unit}`,
                alignment: 'right',
                style: 'textSmall'
              }
            })
          ])
        })

        const docDefinition = {
          styles: {
            textSmall: {
              fontSize: 10
            },
            tableHeader: {
              bold: true,
              fontSize: 10
            },
            generatedLabel: {
              fontSize: 8,
              color: '#A0AFC0'
            },
            title: {
              bold: true
            }
          },
          content: [
            {
              alignment: 'justify',
              columns: [
                {
                  style: 'generatedLabel',
                  text: `Generated on ${moment().format('MMM Do YYYY')}`
                },
                {
                  image: 'logoCorp',
                  width: '70',
                  alignment: 'left'
                }
              ]
            },
            {
              alignment: 'center',
              style: 'title',
              text: '\n AVERAGE REPORT \n'
            },
            {
              alignment: 'center',
              style: 'textSmall',
              text:
                '\n Sensor Type: ' +
                this.sensorTypeOptions.find(
                  (sensorType) => sensorType.value === this.form.sensorType
                )?.label
            },
            {
              alignment: 'center',
              style: 'textSmall',
              text: `Period: ${moment(this.form.startDate).format(
                'MMM Do YYYY'
              )} - ${moment(this.form.endDate).format('MMM Do YYYY')}`
            },
            '\n\n',
            {
              image: 'chart',
              width: '500',
              alignment: 'center'
            },
            '\n\n\n',
            {
              table: {
                headerRows: 1,
                widths: [...Array(tableHeaders.length)].map((x) => '*'),
                body: [...body]
              },
              layout: {
                fillColor: function (rowIndex, node, columnIndex) {
                  return rowIndex % 2 === 0 ? '#E2E8F0' : null
                }
              }
            }
          ],
          images: {
            chart: this.chartBase64,
            logoCorp: imagesLib.logoCorp
          }
        }

        pdfMake
          .createPdf(docDefinition)
          .download(`Average Report ${moment().format('MMM Do YYYY')}.pdf`)
      } catch (err) {
        console.log('inimang error printToPDF', err)
      }
    }
  }
}
</script>
